/**
 * Safe localStorage / sessionStorage access for inline tracking scripts.
 *
 * - Loaded early via mix: /js/safe-storage-global.js (sync <script> before GTM / pixel partials).
 * - Also imported from app.js; initialization is idempotent.
 */
(function () {
    if (typeof window === 'undefined' || window.__leSafeStorage) {
        return;
    }

    window.__leSafeStorage = {
        get: function (key, storageType) {
            try {
                var type = storageType || 'local';
                var storage = type === 'session' ? window.sessionStorage : window.localStorage;
                return storage ? storage.getItem(key) : null;
            } catch (e) {
                return null;
            }
        },
        set: function (key, value, storageType) {
            try {
                var type = storageType || 'local';
                var storage = type === 'session' ? window.sessionStorage : window.localStorage;
                if (!storage) {
                    return false;
                }
                storage.setItem(key, value);
                return true;
            } catch (e) {
                return false;
            }
        }
    };
})();
